import http from "../../http";

/**
 * 基础公共接口
 * 菜单、城市、标签、行业、领域、管理员、验证码、短链接等
 */
export default {
  // 左侧导航栏
  leftMenuList: (params) => {
    return http.get("opservice/tenant/security/current/menu/left", params);
  },
  // 顶部导航栏
  getmenu: (params) => {
    return http.get("opservice/tenant/security/current/menu/top", params);
  },
  // 获取城市数据（国内）
  getCity: (params) => {
    return http.get("opservice/opbasedocarea/allcity.json", params);
  },
  // 获取城市数据（含海外）
  getCity2: (params) => {
    return http.get("opservice/opbasedocarea/allcityAbroad.json", params);
  },
  // 获取所有的系统标签
  getLabel: (data) => {
    return http.post("opservice/opbasedoclabel/list", data);
  },
  // 获取所有行业
  getAllIndustry: (params) => {
    return http.get("content-service/sys_industry/list", params);
  },
  // 获取所有领域
  getAllField: (params) => {
    return http.get("content-service/sys_field/list", params);
  },
  // 获取产品树（公共选择器）
  getProductTree: (params) => {
    return http.get("cmsservice/productSort/op/tree", params);
  },
  // 获取协作管理员
  getAllAdmin: (data) => {
    return http.post("opservice/enterpriseadmin/paged_all", data);
  },
  // 获取在线人数
  getUserOnline: (params) => {
    return http.post("searchservice/official/website/count/user/online", params);
  },
  // 生成短链接
  generateShortUrl: (params) => {
    return http.post("y/generatecode", params);
  },
  // 获取验证码
  getCode: (params) => {
    return http.get("opservice/regist/code", params);
  },
  // 验证码是否正确
  isTrueCode: (params) => {
    return http.get("opservice/regist/iscode", params);
  },
};
